export default __webpack_public_path__ + "static/media/logo_ave.59c1db58.svg";